// extracted by mini-css-extract-plugin
export default {"container":"WithLabel_container__luIa8","label":"WithLabel_label__HyZ15"};